// extracted by mini-css-extract-plugin
export default {"container":"chemicalsIntro_container__zIewO","swiper":"chemicalsIntro_swiper__baqlE","swiperSlide":"chemicalsIntro_swiperSlide__exj-y"};